// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22hYn","col":"styles_col__3KPUC"};